export default ({
  mapper,
  statusProp,
  hideTooltip,
  to,
}) => ({
  componentName: 'cell-status-with-local-discount',
  componentArgs: {
    mapper,
    statusProp,
    hideTooltip,
    to,
  },
});
